<h2 mat-dialog-title class="flex items-baseline gap-2">Switch</h2>
<mat-dialog-content>
  <p>Switching to this reference type will cause the following data to be lost:</p>
  <ul class="lost-fields-list">
    @for (field of data.lostFields; track field) {
      <li class="lost-field-item">
        <strong>{{ field }}</strong>
      </li>
    }
  </ul>
  <div class="flex items-center gap-2 mt-4">
    <mat-icon class="warning-text" aria-hidden="true">warning</mat-icon>
    <p class="bold">This action cannot be undone. Do you want to continue?</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton (click)="onCancel()" cdkFocusInitial>Cancel</button>
  <button matButton="tonal" (click)="onConfirm()" color="primary">Discard & Continue</button>
</mat-dialog-actions>
